import { FC } from 'react';
import { observer } from 'mobx-react';

import { BodyText, Button, ButtonGroup, Link, Page, Stack } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { TermsStore } from '../stores/terms.store';

import '../assets/pdf-terms-page.css';

export interface PdfTermsPageProps {
    url: string;
    title: string;
}

export const PdfTermsPage: FC<PdfTermsPageProps> = observer(({ url, title }) => {
    const [termsStore] = useDependencies(TermsStore);

    return (
        <Page
            className="pdf-terms-page"
            footer={
                <Stack className="w-100" justifyContent="flex-end">
                    <ButtonGroup>
                        <Button primary outline onClick={termsStore.handleDecline}>
                            Decline
                        </Button>
                        <Button
                            primary
                            loading={termsStore.accepting}
                            onClick={termsStore.handleAccept}
                        >
                            Accept
                        </Button>
                    </ButtonGroup>
                </Stack>
            }
            spacing="none"
        >
            <object className="pdf-terms-viewer" data={url} type="application/pdf" title={title}>
                <BodyText className="m-2">
                    {'Your browser can’t display PDF files. Please download the '}
                    <Link color="primary" href={url} target="_blank">
                        {title}
                    </Link>
                    {' and open the file in a PDF viewer such as Acrobat Reader.'}
                </BodyText>
            </object>
        </Page>
    );
});
PdfTermsPage.displayName = 'PdfTermsPage';
